import { useState, useEffect } from "react";
import { estadosAPI } from "../../api";
import toast from "react-hot-toast";

export default function Estados() {
  const [estados, setEstados] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [nuevo, setNuevo] = useState("");
  const [guardando, setGuardando] = useState(false);

  const cargar = async () => {
    setCargando(true);
    try {
      const res = await estadosAPI.listar();
      setEstados(res.data.data);
    } catch {
      toast.error("Error cargando estados");
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => { cargar(); }, []);

  const handleAgregar = async (e) => {
    e.preventDefault();
    if (!nuevo.trim()) return;
    setGuardando(true);
    try {
      const res = await estadosAPI.crear(nuevo.trim());
      setEstados((prev) => [...prev, res.data.data].sort((a, b) => a.nombre.localeCompare(b.nombre)));
      setNuevo("");
      toast.success("Estado agregado");
    } catch (err) {
      toast.error(err.response?.data?.message || "Error agregando estado");
    } finally {
      setGuardando(false);
    }
  };

  const handleEliminar = async (id, nombre) => {
    if (!window.confirm(`¿Eliminar "${nombre}"?`)) return;
    try {
      await estadosAPI.eliminar(id);
      setEstados((prev) => prev.filter((e) => e.id !== id));
      toast.success("Estado eliminado");
    } catch {
      toast.error("Error eliminando estado");
    }
  };

  return (
    <div className="fade-in" style={{ maxWidth: 560 }}>
      <div className="page-header">
        <div>
          <h1 className="heading-serif page-title">Estados</h1>
          <p style={{ color: "var(--color-text-muted)", fontSize: ".9rem" }}>
            Administra los estados disponibles al crear propiedades
          </p>
        </div>
      </div>

      {/* Formulario agregar */}
      <div className="card" style={{ padding: "1.25rem", marginBottom: "1.5rem" }}>
        <form onSubmit={handleAgregar} style={{ display: "flex", gap: ".75rem" }}>
          <input
            className="form-input"
            value={nuevo}
            onChange={(e) => setNuevo(e.target.value)}
            placeholder="Ej: Veracruz, Oaxaca, Puebla..."
            autoFocus
          />
          <button
            type="submit"
            className="btn btn-accent"
            disabled={guardando || !nuevo.trim()}
            style={{ whiteSpace: "nowrap" }}
          >
            {guardando ? "..." : "+ Agregar"}
          </button>
        </form>
      </div>

      {/* Lista */}
      <div className="card">
        {cargando ? (
          <div className="spinner" style={{ margin: "2rem auto" }} />
        ) : estados.length === 0 ? (
          <div style={{ padding: "3rem", textAlign: "center", color: "var(--color-text-muted)" }}>
            <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>🗺️</div>
            <p>No hay estados. Agrega el primero arriba.</p>
          </div>
        ) : (
          <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
            {estados.map((estado, i) => (
              <li
                key={estado.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: ".85rem 1.25rem",
                  borderBottom: i < estados.length - 1 ? "1px solid var(--color-border)" : "none",
                }}
              >
                <span style={{ fontWeight: 500 }}>🗺️ {estado.nombre}</span>
                <button
                  className="btn btn-ghost btn-sm"
                  style={{ color: "var(--color-error)" }}
                  onClick={() => handleEliminar(estado.id, estado.nombre)}
                >
                  🗑️ Eliminar
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>

      <p style={{ marginTop: "1rem", fontSize: ".8rem", color: "var(--color-text-muted)" }}>
        {estados.length} estado{estados.length !== 1 ? "s" : ""} registrado{estados.length !== 1 ? "s" : ""}
      </p>
    </div>
  );
}
